module.exports = "<app-navbar></app-navbar>\n<div class=\"wrapper\">\n\t<app-sidebar  [ngStyle]=\"sidebarConfig.main\" [options]=\"sidebarConfig\" [items]=\"menuItems\"></app-sidebar>\n\t<!-- Page Content Holder -->\n\t<div class=\"content container-fluid\">\n\t\t<router-outlet></router-outlet>\n\t</div>\n</div>\n<app-footer></app-footer>\n"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/MileTrack-Frontend-AWS-S3/src/app/layout/dashboard-layout/dashboard-layout.component.html
// module id = ../../../../../src/app/layout/dashboard-layout/dashboard-layout.component.html
// module chunks = main